export const CALENDAR_VIEW_MODE = {
  DAY: 'day',
};

export const CALENDAR_DISPLAY_MODE = {
  LIST: 'list',
  CALENDAR: 'calendar',
};

export const CALENDAR_DISPLAY_MODE_OPTIONS = [
  { value: CALENDAR_DISPLAY_MODE.LIST, label: 'List View' },
  { value: CALENDAR_DISPLAY_MODE.CALENDAR, label: 'Calendar View' },
];

export const CALENDAR_LANGUAGES = {
  SWEDISH: 'sv',
  ENGLISH: 'en',
};

export const CALENDAR_LANGUAGE_OPTIONS = [
  { value: CALENDAR_LANGUAGES.SWEDISH, label: 'Swedish' },
  { value: CALENDAR_LANGUAGES.ENGLISH, label: 'English' },
];

export const CALENDAR_TIME_FORMAT = {
  TWELVE_HOUR: '12h',
  TWENTY_FOUR_HOUR: '24h',
};

export const CALENDAR_TIME_FORMAT_OPTIONS = [
  { value: CALENDAR_TIME_FORMAT.TWENTY_FOUR_HOUR, label: '24 hours' },
  { value: CALENDAR_TIME_FORMAT.TWELVE_HOUR, label: '12 hours' },
];

export const CALENDAR_DAYS_TO_SHOW = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
};

export const CALENDAR_DAYS_OPTIONS = [
  { value: CALENDAR_DAYS_TO_SHOW.ONE, label: '1 day' },
  { value: CALENDAR_DAYS_TO_SHOW.TWO, label: '2 days' },
  { value: CALENDAR_DAYS_TO_SHOW.THREE, label: '3 days' },
  { value: CALENDAR_DAYS_TO_SHOW.FOUR, label: '4 days' },
  { value: CALENDAR_DAYS_TO_SHOW.FIVE, label: '5 days' },
];

export const CALENDAR_SOURCE_TYPE = {
  URL: 'url',
  FILE: 'file',
};

export const CALENDAR_SOURCE_OPTIONS = [
  { value: CALENDAR_SOURCE_TYPE.URL, label: 'URL' },
  { value: CALENDAR_SOURCE_TYPE.FILE, label: 'Upload File' },
];

export const CALENDAR_FILE_EXTENSIONS = {
  ICS: '.ics',
  ICAL: '.ical',
};

export const CALENDAR_FILE_ACCEPT =
  CALENDAR_FILE_EXTENSIONS.ICS + ',' + CALENDAR_FILE_EXTENSIONS.ICAL;

export const CALENDAR_MESSAGES = {
  NO_EVENTS: {
    sv: 'Inga kommande händelser',
    en: 'No upcoming events',
  },
  LOADING: {
    sv: 'Laddar kalenderhändelser...',
    en: 'Loading calendar events...',
  },
  FILE_UPLOAD: {
    CHOOSE: 'Choose ICS file',
    INVALID_TYPE: 'Please upload a valid ICS file (.ics or .ical)',
    READ_ERROR: 'Error reading file. Please try again.',
  },
};

export const CALENDAR_MAX_EVENTS_PER_DAY = {
  1: null,
  2: 4,
  3: 3,
  4: 2,
  5: 2,
};

export const CALENDAR_MAX_EVENTS_RANGE = {
  MIN: 1,
  MAX: 8,
  DEFAULT: 5,
};

export const calendarDefaultOptions = {
  name: 'Calendar Widget',
  viewMode: CALENDAR_VIEW_MODE.DAY,
  language: CALENDAR_LANGUAGES.SWEDISH,
  timeFormat: CALENDAR_TIME_FORMAT.TWENTY_FOUR_HOUR,
  textFont: 'Poppins',
  titleFontSize: 20,
  subtitleFontSize: 14,
  eventTitleFontSize: 18,
  eventSubtitleFontSize: 12,
  fontColor: '#000000',
  backgroundColor: '#FFFFFF',
  headerBackgroundColor: '#E3003A',
  headerTextColor: '#FFFFFF',
  headerSecondaryBackgroundColor: '#FFE6EE',
  headerSecondaryTextColor: '#E3003A',
  opacity: 100,
  displayMode: CALENDAR_DISPLAY_MODE.LIST,
  daysToShow: CALENDAR_DAYS_TO_SHOW.ONE,
  maxEvents: CALENDAR_MAX_EVENTS_RANGE.DEFAULT,
  maxEventsPerDay: CALENDAR_MAX_EVENTS_RANGE.DEFAULT,
  icsUrl: '',
  useDemoData: false,
  sourceType: CALENDAR_SOURCE_TYPE.URL,
  icsFileContent: null,
  fileName: '',
  eventBackgroundColor: '#FFFFFF',
  eventDateBackgroundColor: '#F0F0F0',
  eventTitleFont: 'Poppins',
  eventTitleColor: '#1A1A1A',
  eventTitleSize: 24,
  eventTimeFont: 'Poppins',
  eventTimeColor: '#E3003A',
  eventTimeSize: 14,
  eventDescriptionFont: 'Poppins',
  eventDescriptionColor: '#6B7280',
  eventDescriptionSize: 14,
  eventBorderColor: '#F0F0F0',
  eventBorderWidth: 2,
  weekdayHeaderFont: 'Poppins',
  weekdayHeaderColor: '#6C757D',
  weekdayHeaderSize: 14,
  dateHeaderFont: 'Poppins',
  dateHeaderColor: '#2C3E50',
  dateHeaderSize: 18,
  listDateDayFont: 'Poppins',
  listDateDayColor: '#000000',
  listDateDaySize: 32,
  listDateFont: 'Poppins',
  listDateColor: '#666666',
  listDateSize: 12,
};

export const DEFAULT_FETCH_INTERVAL = 5;
